import React from "react";
import PropTypes from "prop-types";
import { Image } from "@learningblocks/shared-components";
import ArrowUp from "@common/images/Arrow-Up.svg";
import { useIntl } from "react-intl";
import style from "./style.module.scss";

export function GoBackIcon(props) {
  const intl = useIntl();
  const className = `${style.icon} ${props.className}`;
  return (
    <Image
      className={className}
      src={ArrowUp}
      alt={intl.formatMessage({
        id: "Go back",
        defaultMessage: "Go back",
        description: "",
      })}
    />
  );
}

GoBackIcon.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
};

GoBackIcon.defaultProps = {
  className: "",
};
